import { parseISO, format, isBefore, getDate, getMonth } from 'date-fns';
import { de } from 'date-fns/locale';

export const PROMOTION_DEADLINE = '2025-10-31T23:59:59';

const state = {
    deadline: PROMOTION_DEADLINE,
    discountPercentage: 50,
    regularPrice: 16,
    discountedPrice: 8,
    durationMonths: 6,
    terminalIncluded: true,
    terminalName: 'myPOS Go 2',
};

const mutations = {
    SET_PROMOTION_DEADLINE(state, deadline) {
        state.deadline = deadline;
    },
};

const actions = {};

const getters = {
    promotionDeadline: (state) => {
        return parseISO(state.deadline);
    },

    showPromotion: (state) => {
        const now = new Date();
        const deadline = parseISO(state.deadline);
        return isBefore(now, deadline) || now.getTime() === deadline.getTime();
    },

    promotionDeadlineFormatted: (state) => {
        const deadline = parseISO(state.deadline);
        return format(deadline, 'd. MMMM yyyy', { locale: de });
    },

    promotionDeadlineShort: (state) => {
        const deadline = parseISO(state.deadline);
        return format(deadline, 'dd.MM.yyyy');
    },

    promotionDeadlineAbbreviated: (state) => {
        const deadline = parseISO(state.deadline);
        const day = getDate(deadline);
        const monthNames = [
            'Jan',
            'Feb',
            'Mär',
            'Apr',
            'Mai',
            'Jun',
            'Jul',
            'Aug',
            'Sep',
            'Okt',
            'Nov',
            'Dez',
        ];
        const month = monthNames[getMonth(deadline)];
        return `${day}.${month}`;
    },

    discountPercentage: (state) => state.discountPercentage,
    regularPrice: (state) => state.regularPrice,
    discountedPrice: (state) => state.discountedPrice,
    durationMonths: (state) => state.durationMonths,
    terminalIncluded: (state) => state.terminalIncluded,
    terminalName: (state) => state.terminalName,
    discountBadgeText: (state) => `${state.discountPercentage}% RABATT`,
    priceComparison: (state) => `${state.discountedPrice}€ statt ${state.regularPrice}€`,
};

export default {
    namespaced: true,
    state,
    mutations,
    actions,
    getters,
};
